<template>
  <v-container fluid v-resize="onResize">
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        :server-items-length="totalRecords"
        @update:options="updateOptions"
        :loading="loading"
        :footer-props="{
            'items-per-page-options': [20, 50, 100, 250]
          }"
        :height="windowSize.y - subtractHeight"
        fixed-header
        :item-class="itemRowBackground"
    >
      <template v-slot:top>
        <v-toolbar ref="RefListTop">
          <v-container fluid>
            <v-row no-gutters>
              <v-spacer></v-spacer>
                <v-checkbox
                    v-model="uncheckedFilter"
                    label="only unchecked"
                    @change="onUpdateFilters"
                ></v-checkbox>
            </v-row>
          </v-container>
        </v-toolbar>

      </template>
      <template v-slot:item.checked="{ item }">
        <span v-if="userId === null">
          <v-checkbox v-model="item.checked" @change="onChecked(item)"></v-checkbox>
        </span>
        <span v-else>
          <v-simple-checkbox :value="item.checked"></v-simple-checkbox>
        </span>
      </template>
      <template v-slot:item.event="{ item }">
        <v-chip dark :color="getEventColor(item)">
          <span class="font-weight-bold">{{ item.event }}</span>
        </v-chip>
      </template>
      <template v-slot:item.event_start="{ item }">
        <span v-if="item.event_start">
          {{ item.event_start | moment("DD.MM.YYYY") }}
        </span>
      </template>
      <template v-slot:item.created_on="{ item }">
        <span v-if="item.created_on">{{ item.created_on | moment("DD.MM.YYYY HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.edited_on="{ item }">
        <span v-if="item.edited_on">{{ item.edited_on | moment("DD.MM.YYYY HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.created_by="{ item }">
        <span v-if="item.created_by">{{ item.created_by.username }}</span>
      </template>
      <template v-slot:item.edited_by="{ item }">
        <span v-if="item.edited_by">{{ item.edited_by.username }}</span>
      </template>
    </v-data-table>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';


export default {
  name: 'TimeTrackerEventHoliday',
  props: {
    subtractHeight: {type: [Number], default: 400},
    height: {type: [Number], default: window.innerHeight},
    userId: {default: null},
    date: {default: null},
    dto_model: {type: [String], default: 'TimeTrackerEventDTO'},
    uncheckedInit: {type: [Boolean], default: null},
    deletedInit: {type: [Boolean], default: null},
    errorInit: {type: [Boolean], default: null},
  },

  components: {
  },

  computed: {
    ...mapGetters('TimeTrackerHoliday', ['getColumns']),
    ...mapFields('TimeTrackerHoliday', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase']),
  },
  watch: {
    date: function (newVal, oldVal) { // watch it
      // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.localFilterDate = newVal
      this.onUpdateFilters()
    },
  },

  methods: {
    ...mapActions('TimeTrackerHoliday', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),

    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

    itemRowBackground: function (item) {
      // console.log('row click', item)
      if (item.error_message != null)
        return "event_error"
      else
        return "event_" + item.event
    },

    getEventColor: function (item) {
      return this.local_phrase[item.event].color
    },

    onChecked(item) {
      // console.log('onChecked', item)
      this.fetchSaveItemField({
        itemId: item.id,
        fields_dict: {deleted: item.deleted, checked: item.checked},
        dto_model: {to_consumer: this.dto_model, from_consumer: this.dto_model}
      })
    },

    updateOptions() {
      // console.log('updateOptions', this.userId)
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateFilters() {
      // console.log('updateOptions', this.userId, this.filterEvents, this.startMonth, this.endMonth)
      this.options.page = 1

      this.filters = {}

      if (this.uncheckedFilter)
        this.filters['unchecked'] = false
      else
        this.filters['unchecked'] = null

      this.filters['not_deleted'] = true

      if (this.userId !== null)
        this.filters['user_id'] = this.userId

      if (this.filterEvents.length !== 0)
        this.filters['events'] = this.filterEvents
      else
        this.filters['events'] = []

      this.filters['date'] = this.localFilterDate
      this.filters['start_datetime'] = new Date().toISOString().slice(0, 10) + " 00:00:00"
      this.filters['end_datetime'] = null

      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

  },

  async mounted() {
    // console.log('mounted')
    this.briefView = this.userId != null
    window.addEventListener("resize", this.onResize)
    this.onResize()
    this.searchTerm = null
    if (this.uncheckedInit !== null) {
      this.uncheckedFilter = this.uncheckedInit
    }
    if (this.deletedInit !== null) {
      this.deletedFilter = this.deletedInit
    }
    if (this.deletedInit !== null) {
      this.errorMessageFilter = this.errorInit
    }
    this.onUpdateFilters()
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  beforeDestroy() {
  },

  data() {
    return {
      localFilterDate: this.date,
      windowSize: {x: 0, y: 0,},
      userSelected: null,
      filterEvents: ['holiday'],
      eventsList: ['tracker', 'working', 'pause', 'time_correction', 'HRPayed', 'holiday', 'holiday_extra', 'sick', 'sick_with_child'],
      errorMessageFilter: false,
      uncheckedFilter: false,
      deletedFilter: false,
      startMonth: null,
      endMonth: null,
      onlyActiveUser: true,
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.event_working, .event_work_kug {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.event_holiday, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child, .event_sick_kug {
  background-color: #FFF8E1 !important;
}

.event_error {
  background-color: #FFEBEE !important;
}

</style>
